import styled from 'styled-components'

export const MDAAParentContainer = styled.div`
  width: 100%;
  padding: 20px 20px 75px;
  font-family: Outfit;
  margin: auto;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 64px - 40px);
  position: relative;
  @media (min-width: 768px) {
    padding: 40px 40px 150px;
  }
`

export const MDAAHeading = styled.div`
  text-align: center;
  font-size: ${(props) => (props?.desc ? '12px' : '22px')};
  font-weight: ${(props) => (props?.desc ? '400' : '500')};
  @media (min-width: 768px) {
    font-size: ${(props) => (props?.desc ? '16px' : '28px')};
  }
`

export const MDAADeleteButton = styled.button`
  background: #f54435;
  padding: 4px 8px;
  border-radius: 4px;
  color: #fff;
  transition: all 0.1s ease-in-out;
  &:disabled {
    background: #65737b;
  }
`

const AvatarGenericContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: 500;
  background: ${(props) => props?.backgroundColor};
  color: ${(props) => props?.fontColor};
  width: ${(props) => props?.containerSizeInPixels};
  height: ${(props) => props?.containerSizeInPixels};
  font-size: ${(props) => props?.fontSizeInPixels};
`

export const MDAAFaqBoxesContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
`

export const MDAAFaqBox = styled.div`
  padding: 16px;
  background: #eaedff;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  font-weight: 500;
  width: 250px;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 5px;
  }
`

// components:

export const AvatarGenericLetterComponent = ({
  name,
  backgroundColor,
  textColor,
  containerSizeInPixels,
  fontSizeInPixels,
}) => {
  return (
    <AvatarGenericContainer
      backgroundColor={backgroundColor || '#514387'}
      fontColor={textColor || '#fff'}
      containerSizeInPixels={containerSizeInPixels || '75px'}
      fontSizeInPixels={fontSizeInPixels || '30px'}
    >
      {name?.charAt(0)?.toUpperCase()}
    </AvatarGenericContainer>
  )
}
